module.exports = new __parcel__URL__("development.ce6d1083.svg").toString();